(function() {
    'use strict';
    angular
        .module('askApp')
        .factory('DinghyBooking', DinghyBooking);

    DinghyBooking.$inject = ['$resource', 'DateUtils'];

    function DinghyBooking ($resource, DateUtils) {
        var resourceUrl =  'api/dinghy-bookings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.bookingDate = DateUtils.convertDateTimeFromServer(data.bookingDate);
                        data.validationDate = DateUtils.convertDateTimeFromServer(data.validationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
